function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var toArray = require('@uppy/utils/lib/toArray');

var _require2 = require('preact'),
    h = _require2.h;

var locale = require('./locale');

module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(FileInput, _UIPlugin);

  var _super = _createSuper(FileInput);

  function FileInput(uppy, opts) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _super.call(this, uppy, opts);
    _this.id = _this.opts.id || 'FileInput';
    _this.title = 'File Input';
    _this.type = 'acquirer';
    _this.defaultLocale = locale; // Default options

    var defaultOptions = {
      target: null,
      pretty: true,
      inputName: 'files[]'
    }; // Merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    _this.i18nInit();

    _this.render = _this.render.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileInput, [{
    key: "addFiles",
    value: function addFiles(files) {
      var _this2 = this;

      var descriptors = files.map(function (file) {
        return {
          source: _this2.id,
          name: file.name,
          type: file.type,
          data: file
        };
      });

      try {
        this.uppy.addFiles(descriptors);
      } catch (err) {
        this.uppy.log(err);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      this.uppy.log('[FileInput] Something selected through input...');
      var files = toArray(event.target.files);
      this.addFiles(files); // We clear the input after a file is selected, because otherwise
      // change event is not fired in Chrome and Safari when a file
      // with the same name is selected.
      // ___Why not use value="" on <input/> instead?
      //    Because if we use that method of clearing the input,
      //    Chrome will not trigger change if we drop the same file twice (Issue #768).

      event.target.value = null;
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.input.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      /* http://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/ */
      var hiddenInputStyle = {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
      };
      var restrictions = this.uppy.opts.restrictions;
      var accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(',') : null;
      return h("div", {
        className: "uppy-Root uppy-FileInput-container"
      }, h("input", {
        className: "uppy-FileInput-input",
        style: this.opts.pretty && hiddenInputStyle,
        type: "file",
        name: this.opts.inputName,
        onChange: this.handleInputChange,
        multiple: restrictions.maxNumberOfFiles !== 1,
        accept: accept,
        ref: function ref(input) {
          _this3.input = input;
        }
      }), this.opts.pretty && h("button", {
        className: "uppy-FileInput-btn",
        type: "button",
        onClick: this.handleClick
      }, this.i18n('chooseFiles')));
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);

  return FileInput;
}(UIPlugin), _class.VERSION = "2.0.5", _temp);